module.exports = __webpack_public_path__ + "img/cargo_parked.a9021335.svg";